module.exports = __webpack_public_path__ + "static/service-hair-bbecb5ff462c09ef7fe8648dd029e16d.jpg";